/**
 * Returns true if string contains a valid URL that uses the http or https protocol.
 */
export const isValidHttpUrl = (str: string) => {
	const containsProtocolPrefix =
		typeof str === "string" && (str.startsWith("http:") || str.startsWith("https:"));

	if (!containsProtocolPrefix) {
		return false;
	}

	try {
		new URL(str);
	} catch (e) {
		return false;
	}

	return true;
};
